'use strict';

// dom
const {
	div, p, section
} = require('iblokz-snabbdom-helpers');
// comp
const breadcrumb = require('./breadcrumb');
const resources = require('./resources');

// custom admin UIs (override generic schema-driven resources when present)
const custom = {
	users: require('./users')
};

module.exports = ({state, actions, i18n}) => {
	const collection = state.router.path[1];
	return section('.admin', [
		breadcrumb({state, actions, i18n}),
		custom[collection]
			? custom[collection]({state, actions, i18n})
			: state.rest.routes.api[collection]
				? resources({state, actions, i18n})
				: div(p('Welcome to admin'))
	]);
};
